import React from "react"
import strings from "../../localization/strings"
import { ELanguage, IQuestion } from "../../models"
import { Tabs, Tab } from "material-ui"
import PunchQuestionBodyTab from "./PunchQuestionBodyTab"
interface IProps {
    readonly: boolean
    questions: IQuestion[]
    selectedLanguages: ELanguage[]
    handleChange(questions: IQuestion[]): void
}

const PunchQuestionBody: React.SFC<IProps> = (props: IProps) => {
    return (
        <Tabs style={{ marginTop: 20, marginLeft: -16, marginRight: -16 }}>
            <Tab data-intercom-target={`${strings.Punch_In_Questions}-Tab`} label={strings.Punch_In_Questions} >
                <PunchQuestionBodyTab
                    selectedLanguages={props.selectedLanguages}
                    punchIn
                    readonly={props.readonly}
                    questions={props.questions.filter(i => i.PunchIn)}
                    handleChange={punchInQuestions => {
                        const punchOutQuestions = props.questions.filter(i => !i.PunchIn)
                        const questions = punchInQuestions.concat(punchOutQuestions)
                        props.handleChange(questions)
                    }}
                />
            </Tab>
            <Tab data-intercom-target={`${strings.Punch_Out_Questions}-Tab`} label={strings.Punch_Out_Questions} >
                <PunchQuestionBodyTab
                    selectedLanguages={props.selectedLanguages}
                    punchIn={false}
                    readonly={props.readonly}
                    questions={props.questions.filter(i => !i.PunchIn)}
                    handleChange={punchOutQuestions => {
                        const punchInQuestions = props.questions.filter(i => i.PunchIn)
                        const questions = punchInQuestions.concat(punchOutQuestions)
                        props.handleChange(questions)
                    }}
                />
            </Tab>
        </Tabs>
    )
}

export default PunchQuestionBody
